<p-button
  [type]="type || 'text'"
  [label]="label"
  [type]="type"
  [styleClass]="styleClass"
  (onClick)="handleClick($event)"
  [disabled]="disabled"
  [loading]="loading"
  [severity]="severity"
  [size]="size"></p-button>
